import { render, staticRenderFns } from "./OptionSelectableTextPropertyEditor.vue?vue&type=template&id=8ab127ac&scoped=true&"
import script from "./OptionSelectableTextPropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./OptionSelectableTextPropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab127ac",
  null
  
)

export default component.exports